import { S as Swiper } from './swiper-core-01Cb2G-G.js';
import { N as Navigation, P as Pagination, A as A11y, K as Keyboard } from './a11y-BtzuDeT2.js';

/**
 * Thin Web Component wrapper around Swiper.
 *
 * Markup contract:
 *   <swiper-slider data-options='{ ...SwiperOptions }'>
 *     <div class="swiper">
 *       <div class="swiper-wrapper">
 *         <div class="swiper-slide">…</div>
 *       </div>
 *     </div>
 *     <button data-swiper-prev>…</button>
 *     <button data-swiper-next>…</button>
 *   </swiper-slider>
 *
 * `data-options` is parsed as JSON and merged over the defaults. Navigation is
 * wired automatically when both nav buttons are present inside the element.
 */
class SwiperSlider extends HTMLElement {
  #swiper = null;

  connectedCallback() {
    const container = this.querySelector('.swiper');
    if (!container || this.#swiper) return;

    let options = {};
    try {
      options = JSON.parse(this.dataset.options || '{}');
    } catch {
      options = {};
    }

    const prevEl = this.querySelector('[data-swiper-prev]');
    const nextEl = this.querySelector('[data-swiper-next]');

    this.#swiper = new Swiper(container, {
      modules: [Navigation, Pagination, A11y, Keyboard],
      slidesPerView: '4',
      ...options,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
    });
  }

  disconnectedCallback() {
    if (this.#swiper) {
      this.#swiper.destroy(true, true);
      this.#swiper = null;
    }
  }
}

if (!customElements.get('swiper-slider')) {
  customElements.define('swiper-slider', SwiperSlider);
}
